import React from 'react'

export function SmartForms() {
  return (
    <div className="relative bg-slate-200 py-[8vmin] px-4 md:px-0 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid items-center">
          <div className="max-w-2xl mx-auto text-center mt-12">
            <h2 className="mt-6 text-4xl md:text-7xl font-bold text-black font-hdg">
              Forms that think for you
            </h2>
            <p className="max-w-2xl mx-auto mt-6 text-lg lg:text-xl text-slate-700 font-hdg">
              Use AI to generate forms in seconds, apply smart logic, and adapt
              every question based on responses — so you always get the right
              data.
            </p>
            <a
              className="inline-block mt-6 text-lg lg:text-xl text-blue-600 font-semibold font-hdg hover:underline"
              href="https://my.heyform.net/sign-up"
            >
              Generate a form with AI →
            </a>
          </div>
        </div>

        <div className="w-full max-w-8xl mx-auto bg-white mt-12 rounded-lg md:rounded-xl lg:rounded-2xl overflow-hidden shadow-sm">
          <img src="/static/smart.webp" alt="Create forms with AI" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="mt-10 lg:mt-20 grid gap-[6vmin] grid-cols-1 md:grid-cols-12 items-start">
          <div className="col-span-6">
            <div className="w-full bg-white rounded-md">
              <img
                src="/static/features/conditional-logic.webp"
                alt="Conditional logic"
                width="1350"
                height="686"
                loading="lazy"
                className="rounded-md"
              />
            </div>
            <h3 className="mt-10 text-2xl lg:text-3xl font-bold text-black leading-none">
              Conditional logic
            </h3>
            <p className="max-w-xl mt-6 text-lg  md:text-xl leading-normal font-normal text-slate-700 font-hdg">
              Show the right questions at the right time.
              Automatically adapt your form based on responses — so every user gets a personalized flow.
            </p>
          </div>

          <div className="col-span-6">
            <div className="w-full bg-white rounded-md">
              <img
                src="https://s2.loli.net/2024/10/04/c8rkzH1JwpVIhWO.png"
                alt="Multiple endings"
                width="1350"
                height="686"
                loading="lazy"
                className="rounded-md"
              />
            </div>
            <h3 className="mt-10 text-2xl lg:text-3xl font-bold text-black leading-none">
              Multiple endings
            </h3>
            <p className="max-w-xl mt-6 text-lg md:text-xl leading-normal font-normal text-slate-700 font-hdg">
              One form, multiple outcomes.
              Show different results, redirect users, or trigger next steps based on their answers.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
